// Navigation
let navButton = document.querySelector(".nav__button");
let nav = document.querySelector(".navbar-collapse");

function toggleNav(isOpen) {
    navButton.classList.toggle("nav__button--open", isOpen);
    nav.classList.toggle("open", isOpen);
    document.body.classList.toggle("overflow-hidden", isOpen);
}

function closeNav() {
    toggleNav(false);
}

navButton.addEventListener("click", (event) => {
    toggleNav(!navButton.classList.contains("nav__button--open"));
});

window.addEventListener("resize", closeNav);


// MAIL
let user = 'info'; 
let domain = 'spektakulum.net';
let emailElements = document.querySelectorAll('.main_mail');

emailElements.forEach(function(element) {
    element.innerHTML = '<a class="mail" href="mailto: Spektakulum <' + user + '@' + domain + '> ?subject=Kontakt via spektakulum.de">' + user + '@' + domain + '</a>';
});
